import { CircleCheckFilled } from '@/frontend/SVGs/CircleCheckFilled';
import { I18n } from '@/i18n/I18n';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

export function ValidationsPassingIcon(props: { singleValidation?: boolean }) {
  const { singleValidation } = props;
  const label = singleValidation ? I18n.get('validationPassed') : I18n.get('validationsAllPassing');

  return (
    <OverlayTrigger
      placement='top'
      overlay={<Tooltip>
        {label}
      </Tooltip>}
    >
      <div aria-label={label}>
        <CircleCheckFilled color="var(--green-600)" />
      </div>
    </OverlayTrigger>
  );
}
